import { Route, Routes } from 'react-router-dom';
import { integrationsDetailsSubRouteRef } from '../../routes';
import { PulseIntegrationsPage } from './integrations-page';
import { PulseIntegrationsDetails } from './integrations-details';

export const PulseIntegrationsRouting = () => {
  return (
    <Routes>
      <Route path="/" element={<PulseIntegrationsPage />} />
      <Route
        path={integrationsDetailsSubRouteRef.path}
        element={<PulseIntegrationsDetails />}
      />
    </Routes>
  );
};
